module.exports = __webpack_public_path__ + "static/media/ageScotlandLogo.203d529d.png";